import { useEffect } from 'react'
import { Button, Loading } from 'components'
import { useAccountActions } from 'hooks/userHooks'
import { noop } from 'utils'
export type IndexRecordBtnProps = {
  userId: string
  disabled?: boolean
  onDone?: (message: string) => void
  onError?: (message: string) => void
}
export const IndexRecordBtn = ({
  disabled = false,
  userId,
  onDone = noop,
  onError = noop,
}: IndexRecordBtnProps) => {
  const [state, { indexRecord }] = useAccountActions()
  useEffect(() => {
    if (state.matches('success')) {
      onDone('User record indexed')
    } else if (state.matches('failed')) {
      onError('Failed index record, please try again')
    }
  }, [state, onDone, onError])
  return (
    <Button
      type="button"
      variant="buttons.outline"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
      }}
      disabled={disabled || state.matches('syncing')}
      onClick={() => indexRecord({ userId })}>
      {state.matches('syncing') ? <Loading /> : <span>Index record</span>}
    </Button>
  )
}
